import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../../config/notification.service';
import { AppService } from '../../Services/app.service';
import { GoogleLoginProvider } from '../../../../projects/lib/src/providers/google-login-provider';
import { GoogleLoginService } from './google-login.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-google-login',
  templateUrl: './google-login.component.html'
})

export class GoogleLoginComponent implements OnInit {

  userId: any;
  user: any;
  loginForm!: FormGroup;
  signUpForm!: FormGroup;
  hidePassword: boolean = true;
  hidePassword1: boolean = true;
  showToggle: boolean = true;

  constructor(
    private router: Router,
    private appService: AppService,
    private googleLoginService: GoogleLoginService,
    private toastr: NotificationService
  ) { }

  ngOnInit(): void {
    this.router.navigate(['']);
    this.userId = sessionStorage.getItem('id');
    this.tokenCheck();
    this.loginForm = new FormGroup({
      "vEmail": new FormControl('', { validators: [Validators.required] }),
      "vPassword": new FormControl('', []),
      "recaptcha": new FormControl('', Validators.required)
    });
    this.signUpForm = new FormGroup({
      "vFirstName": new FormControl('', { validators: [Validators.required] }),
      "vLastName": new FormControl('', { validators: [Validators.required] }),
      "vEmail": new FormControl('', { validators: [Validators.required] }),
      "vPassword": new FormControl('', { validators: [Validators.required] }),
      "confirmPassword": new FormControl('', { validators: [Validators.required] })
    })
  }
  get f(): any {
    return this.signUpForm.controls;
  }

  signInHandler(): void {
    // this.authService.signIn(GoogleLoginProvider.PROVIDER_ID).then((data) => {
    //   sessionStorage.setItem('google_auth', JSON.stringify(data));

      this.user = {
        vEmail: this.loginForm.value.vEmail,
        vPassword: this.loginForm.value.vPassword
      };
      this.googleLoginService.googleLogin(this.user).subscribe((result) => {
        if (result['code'] == 200) {
          console.log(result,'diweundi')
          let name = result['data'].vFirstName.charAt(0).toUpperCase() + result['data'].vFirstName.slice(1) + " " + result['data'].vLastName.charAt(0).toUpperCase() + result['data'].vLastName.slice(1)
          sessionStorage.setItem('user_name', name);
          let firstName = result['data'].vFirstName.charAt(0).toUpperCase() + result['data'].vFirstName.slice(1);
          sessionStorage.setItem('firstName', firstName);
          let UserRole = result['data'].UserRole;
          sessionStorage.setItem('UserRole', UserRole);
          this.toastr.showSuccess(result['message'], '');
          sessionStorage.setItem('id', result['data'].iUserId);
          sessionStorage.setItem("profileImageName", result['data'].imageData)
          var data = sessionStorage.getItem('id');
          sessionStorage.setItem('token', result['data']['vAccessToken']);
          sessionStorage.setItem('id', result['data']['iUserId'])
          this.router.navigate(['dashboard']);
        } else {
          this.toastr.showWarning(result['message'], '');
          this.router.navigate(['/login']);
        }
      })
    // });
  }

  signUpHandler(): void {
    // this.authService.signIn(GoogleLoginProvider.PROVIDER_ID).then((data) => {
    //   sessionStorage.setItem('google_auth', JSON.stringify(data));

      this.user = {
        vEmail: this.signUpForm.value.vEmail,
        vFirstName: this.signUpForm.value.vFirstName,
        vLastName: this.signUpForm.value.vLastName,
        vPassword: this.signUpForm.value.vPassword,
        confirmPassword: this.signUpForm.value.confirmPassword
      };
      this.googleLoginService.signUp(this.user).subscribe((result) => {
        console.log(result,'diweundi')
        if (result['code'] == 201) {
          console.log(result,'diweundi')
          this.showToggle = true;
          // let name = result['data'].vFirstName.charAt(0).toUpperCase() + result['data'].vFirstName.slice(1) + " " + result['data'].vLastName.charAt(0).toUpperCase() + result['data'].vLastName.slice(1)
          // sessionStorage.setItem('user_name', name);
          // let firstName = result['data'].vFirstName.charAt(0).toUpperCase() + result['data'].vFirstName.slice(1);
          // sessionStorage.setItem('firstName', firstName);
          // let UserRole = result['data'].UserRole;
          // sessionStorage.setItem('UserRole', UserRole);
          // this.toastr.showSuccess(result['message'], '');
          // sessionStorage.setItem('id', result['data'].iUserId);
          // sessionStorage.setItem("profileImageName", result['data'].imageData)
          // var data = sessionStorage.getItem('id');
          // sessionStorage.setItem('token', result['data']['vAccessToken']);
          // sessionStorage.setItem('id', result['data']['iUserId'])
          // this.router.navigate(['dashboard']);
        } else {
          this.toastr.showWarning(result['message'], '');
          // this.router.navigate(['/login']);
        }
      })
    // });
  }

  tokenCheck() {
    this.appService.validateUser().subscribe((result: any) => {
      if (result['code'] == 200) {
        this.router.navigate(['/dashboard']);
      }
    }, (err: any) => {
      console.log(err, "err");
    })
  }
}
